import { graphql } from 'gatsby';
import {
  StyledContainer,
  StyledStarContainer,
  StyledStarFilled,
  StyledStarIcon,
  StyledStarList,
  StyledLabel,
  StyledImage,
} from './StarRating.styles';

const StarRating = ({ elements }: Queries.STAR_RATINGFragment) => {
  const { score, score_out_of, icon_star, label, image } = elements;
  const hasLabel = !!label?.value;
  const hasImage = !!image?.value;
  const iconStar = icon_star.value.url;
  const scoreOutOfValue = score_out_of.value;
  const scoreValue = score.value > scoreOutOfValue ? scoreOutOfValue : score.value;
  const scorePercentage = (scoreValue / scoreOutOfValue) * 100;

  return (
    <StyledContainer>
      {hasImage && (
        <StyledImage
          src={image.value.url}
          title={image.value.description ?? ''}
          alt={image.value.description ?? 'Image for rating'}
        />
      )}
      <StyledStarContainer>
        <StyledStarList>
          {Array.from({ length: scoreOutOfValue }, (_, i) => (
            <StyledStarIcon key={i} icon={iconStar} />
          ))}
        </StyledStarList>
        <StyledStarFilled style={{ width: `${scorePercentage}%` }}>
          {Array.from({ length: Math.ceil(scoreValue) }, (_, i) => (
            <StyledStarIcon key={i} icon={iconStar} isFilled />
          ))}
        </StyledStarFilled>
      </StyledStarContainer>
      {hasLabel && <StyledLabel>{label.value}</StyledLabel>}
    </StyledContainer>
  );
};

export default StarRating;

export const fragment = graphql`
  fragment STAR_RATING on kontent_item_star_rating {
    __typename
    elements {
      image {
        value {
          url
          description
        }
      }
      icon_star {
        value {
          url
          description
        }
      }
      score {
        value
      }
      score_out_of {
        value
      }
      label {
        value
      }
    }
    system {
      codename
    }
  }
`;
